import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import ROUTES from "./routes";
import AuthorisationProvider from "src/providers/authorisationProvider";
import { MainLayout as Layout } from "src/layout/mainLayout";
import ErrorBoundary from "src/components/errorBoundary";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {Object.entries(ROUTES).map(([key, route]) => {
        const element = route.isPublic ? (
          <ErrorBoundary>
            <Suspense>
              <route.Component />
            </Suspense>
          </ErrorBoundary>
        ) : (
          <AuthorisationProvider
            roleRequired={route.roleRequired}
            emailVerificationRequired={route.emailVerificationRequired}
          >
            <Layout route={route.displayName}>
              <ErrorBoundary>
                <Suspense>
                  <route.Component />
                </Suspense>
              </ErrorBoundary>
            </Layout>
          </AuthorisationProvider>
        );

        return <Route key={key} path={route.path} element={element} />;
      })}
    </Routes>
  );
};
export default AppRoutes;
